import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-template-preview-dialog',
  templateUrl: './template-preview-dialog.component.html',
  styleUrls: ['./template-preview-dialog.component.css']
})
export class TemplatePreviewDialogComponent implements OnInit {

  title : any
  showDate :any

  constructor(@Inject(MAT_DIALOG_DATA) data: any) { 
    this.title = data.title
    this.showDate = new Date();
  }

  data = [{
    attendeeEmail: "xyyx@chn.aithent.com",
    attendeeId: 10531,
    attendeeIds: null,
    attendeeIsPresent: "Y",
    attendeeLoginFlag: null,
    attendeeName: "Administrator",
    attendeeRole: "Facilitator",
    attendeeRoleCode: "FAC",
    attendeeShortName: "SM",
    createdBy: 523,
    createdOn: new Date(),
    deletedFlag: 0,
    fkCodelstAttendeeRole: 35,
    fkSecUserAttendee: 523,
    isConfidentialFlag: null,
    isGuestUser: null,
    isJoined: "Y",
    lastModifiedBy: null,
    lastModifiedOn: null,
    logType: null,
    meetingId: 45074,
    meetingTypeCode: null,
    orgCode: "CHN",​
    userId: null
      },
      {
        attendeeEmail: "wser@chn.aithent.com",
        attendeeId: 10531,
        attendeeIds: null,
        attendeeIsPresent: "Y",
        attendeeLoginFlag: null,
        attendeeName: "Administrator One",
        attendeeRole: "Attendee",
        attendeeRoleCode: "ATT",
        attendeeShortName: "JM",
        createdBy: 523,
        createdOn: "2022-05-05T05:16:31.000+00:00",
        deletedFlag: 0,
        fkCodelstAttendeeRole: 35,
        fkSecUserAttendee: 523,
        isConfidentialFlag: null,
        isGuestUser: null,
        isJoined: "Y",
        lastModifiedBy: null,
        lastModifiedOn: null,
        logType: null,
        meetingId: 45074,
        meetingTypeCode: null,
        orgCode: "CHN",​
        userId: null
          },
          {
            attendeeEmail: "dfdfd@chn.aithent.com",
            attendeeId: 10531,
            attendeeIds: null,
            attendeeIsPresent: "Y",
            attendeeLoginFlag: null,
            attendeeName: "Administrator Two",
        attendeeRole: "Attendee",
        attendeeRoleCode: "ATT",
        attendeeShortName: "JM",
            createdBy: 523,
            createdOn: "2022-05-05T05:16:31.000+00:00",
            deletedFlag: 0,
            fkCodelstAttendeeRole: 35,
            fkSecUserAttendee: 523,
            isConfidentialFlag: null,
            isGuestUser: null,
            isJoined: "Y",
            lastModifiedBy: null,
            lastModifiedOn: null,
            logType: null,
            meetingId: 45074,
            meetingTypeCode: null,
            orgCode: "CHN",
            userId: null
              }
    ]

  ngOnInit(): void {
  }

}
